var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckfullcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-circle-check",
    "data-name": "Icon fa-solid-circle-check",
    d: "M9,18A9,9,0,1,0,0,9a9,9,0,0,0,9,9ZM12.973,7.348l-4.5,4.5a.84.84,0,0,1-1.192,0L5.031,9.6A.843.843,0,0,1,6.223,8.406l1.652,1.652,3.9-3.906a.843.843,0,0,1,1.192,1.192Z",
    fill: "#0ad69f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckfullcircle);
export default __webpack_public_path__ + "static/media/checkfullcircle.6bcb150cca97331aea4bdb84462ce9dc.svg";
export { ForwardRef as ReactComponent };